import { Text } from "@clipboard-health/ui-components";
import { type TierType } from "@src/appV2/redesign/Tiers/api/schema";

interface RatingsExplanationTitleProps {
  workerTier: TierType;
}

export function RatingsExplanationTitle(props: RatingsExplanationTitleProps): React.ReactElement {
  const { workerTier } = props;
  // eslint-disable-next-line default-case
  switch (workerTier) {
    case "GOLD": {
      return (
        <Text inline semibold variant="h4">
          How to keep my&nbsp;
          <Text
            inline
            semibold
            variant="h4"
            sx={{ color: (theme) => theme.palette.tiers?.gold.text }}
          >
            Gold
          </Text>
          &nbsp;perks?
        </Text>
      );
    }

    case "SILVER": {
      return (
        <Text inline semibold variant="h4">
          How to unlock&nbsp;
          <Text
            inline
            semibold
            variant="h4"
            sx={{ color: (theme) => theme.palette.tiers?.gold.text }}
          >
            Gold
          </Text>
          ?
        </Text>
      );
    }

    case "LIMITED": {
      return (
        <Text inline semibold variant="h4">
          How to unlock&nbsp;
          <Text
            inline
            semibold
            variant="h4"
            sx={{ color: (theme) => theme.palette.tiers?.silver.text }}
          >
            Silver
          </Text>
          ?
        </Text>
      );
    }
  }
}
